import styled from 'styled-components/macro';

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 100%;
  height: 32px;
  margin-left: auto;

  position: relative;

  background-color: #fff;
  border-radius: 4px;
  border: none;
  box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);

  color: ${props => props.theme.text0};
  font-size: 12px;
  font-weight: 600;

  cursor: pointer;
`;
